import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { LocationApiService } from '../../services/location-api-service';
import { LocationDataSource } from '../../services/location-data-source';

@Component({
    selector: 'location-edit-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class LocationsEdit implements OnInit {
  public form: FormGroup;
  public loading: boolean;

  public locationId: number;
  private dataSource: LocationDataSource;

  constructor(
    protected dialogRef: MatDialogRef<LocationsEdit>,
    protected service: LocationApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {}

  ngOnInit() {
    this.locationId = this.data.locationId || null;
    this.dataSource = this.data.dataSource;

    this.form = new FormBuilder().group({
      title: [null, [Validators.required]],
    });

    if (this.data.Location) {
      Object.keys(this.data.Location).forEach((name) => {
        if (this.form.controls[name]) {
          this.form.controls[name].patchValue(this.data.Location[name]);
        }
      });
    }
  }

  onSubmit() {
    const location = this.form.getRawValue();

    this.form.disable();

    this.dataSource.save(this.locationId, location).then(
      (data) => {
        this.dialogRef.close({ ...location, id: data.id });
      },
      (error) => this.form.enable()
    );
  }
}
